/* =========================================================================
   Off The Mat — assets/off-the-mat.js (bearly.art)
   Runs on the Bearly Tools shell. Needs paper.js + JSZip (loaded by the section).
   GA4: pushes om_* events to window.dataLayer; the shared core
   (assets/bearly-tools-core.js) forwards them to GA4.
   Download popup + email gate: the ONE shared popup in the core
   (BT.runWithProgress). This file only passes its wording (stages, gate text,
   done/error text) and the export as `work`; the core shows progress, asks for
   the email once for ALL tools (logged-in customers skip, fail-open), handles
   × / Escape / backdrop (no file; om_email_dismiss) and fires om_email_view /
   om_email_submit. om_download_click + "Used Off The Mat" fire inside `work`,
   after the file is saved.
   ========================================================================= */

/* ---------------- Tracking + Klaviyo helpers ---------------- */
var omTrack = function (name, params) {
  var o = params ? JSON.parse(JSON.stringify(params)) : {};
  o.event = name;
  (window.dataLayer = window.dataLayer || []).push(o);
};

// Klaviyo events go through the core (known email, adds tool + tool_handle; no-op
// until the visitor's email is known).
var omKlaviyoEvent = function (name, props) {
  try { if (window.BT && typeof window.BT.klaviyoEvent === "function") window.BT.klaviyoEvent(name, props); } catch (e) {}
};

/* ---------------- Off The Mat engine ---------------- */
(function () {
  "use strict";

  var root = document.getElementById("om-root");
  if (!root) return;

  var $ = function (id) { return document.getElementById(id); };
  var stage = $("om-stage"), drop = $("om-drop"), preview = $("om-preview"), legend = $("om-legend");
  var fileInput = $("om-file"), meta = $("om-meta"), textWarn = $("om-textWarn"), errBox = $("om-err");
  var wIn = $("om-w"), hIn = $("om-h"), lock = $("om-lock");
  var matSel = $("om-mat"), customMat = $("om-custom"), matW = $("om-mw"), matH = $("om-mh");
  var summary = $("om-summary"), dlCombined = $("om-dl-combined"), dlZip = $("om-dl-zip");

  omTrack("om_tool_view", { page_location: location.href });

  if (typeof window.paper === "undefined" || typeof window.JSZip === "undefined") {
    meta.textContent = "The cutting engine didn't load. Refresh the page to try again.";
    return;
  }

  var UPI = 72; // SVG user units per inch — Design Space assumes 72/in and ignores physical units

  var S = {
    fileName: null,
    root: null,          // paper item, unscaled, topLeft at 0,0
    nativeW: 0, nativeH: 0,
    aspect: 1,
    rasterFull: null,    // full artwork raster (preview)
    rasterCut: null,     // raster excluding whole-kept shapes (blank-tile test)
    leaves: [],          // [{li, p}] global leaf order
    wholeSet: new Set(), // leaf indices kept whole
    sheets: [],          // packed parts sheets
    cutsX: [], cutsY: [],
    tiles: [],           // {x,y,w,h,row,col,empty} in inches
    pieces: 0, tileCount: 0,
    engaged: false
  };

  var hidden = document.createElement("canvas");
  paper.setup(hidden);

  // ---------- helpers ----------
  var START_IN = 23;
  function num(el) { var v = parseFloat(el.value); return isFinite(v) && v > 0 ? v : 0; }
  function matSize() {
    if (matSel.value === "custom") return [num(matW) || 11.5, num(matH) || 11.5];
    var p = matSel.value.split(",").map(Number); return [p[0], p[1]];
  }
  function matLabel() {
    var o = matSel.options[matSel.selectedIndex];
    if (!o) return "";
    if (matSel.value === "custom") { var m = matSize(); return "custom " + m[0] + "x" + m[1]; }
    return (o.parentNode && o.parentNode.label ? o.parentNode.label + " " : "") + o.text.split(" — ")[0];
  }
  function fmt(n) { return n.toFixed(2).replace(/\.?0+$/, ""); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function showErr(msg) { errBox.textContent = msg || ""; errBox.classList.toggle("om-hidden", !msg); }

  function downloadBlob(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.rel = "noopener";
    if ("download" in a) {
      a.download = (window.BT && BT.brandName ? BT.brandName(name) : name);
      document.body.appendChild(a); // required for iOS Safari/Chrome
      a.click();
      a.remove();
    } else {
      window.open(url, "_blank");
    }
    setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
  }

  // ---------- load ----------
  $("om-pick").addEventListener("click", function () { fileInput.click(); });
  $("om-reload").addEventListener("click", function () { fileInput.click(); });
  fileInput.addEventListener("change", function () {
    if (fileInput.files && fileInput.files[0]) readFile(fileInput.files[0]);
    fileInput.value = "";
  });
  ["dragover", "dragenter"].forEach(function (ev) {
    stage.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-over"); });
  });
  ["dragleave", "drop"].forEach(function (ev) {
    stage.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("is-over"); });
  });
  stage.addEventListener("drop", function (e) {
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) readFile(f);
  });

  // ---------- sample (a free SVG Library design, read from the same Shopify Files packs) ----------
  // The SVG pack is stored scrambled per file; this mirrors unscramble() in assets/svg-library.js.
  var SL_KEY = "56cc146efa78ea9d6ea82ba555272cb5";
  function slFnv(str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; } return h || 1; }
  function slUnscramble(bytes, id) {
    var x = slFnv(SL_KEY + ":" + id), out = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) { x ^= (x << 13) >>> 0; x >>>= 0; x ^= x >>> 17; x ^= (x << 5) >>> 0; x >>>= 0; out[i] = bytes[i] ^ (x & 255); }
    return out;
  }
  function fetchSample(btn) {
    var indexUrl = btn.getAttribute("data-index"), id = btn.getAttribute("data-file");
    var base = new URL(".", new URL(indexUrl, location.href)).href;
    return fetch(indexUrl).then(function (r) { if (!r.ok) throw new Error("index " + r.status); return r.json(); }).then(function (idx) {
      var f = (idx.files || []).filter(function (x) { return x.id === id; })[0];
      if (!f || !f.s) throw new Error("sample not in index");
      var pack = idx.packs[f.s[0]], off = f.s[1], len = f.s[2];
      var url = base + pack[0] + "?v=" + pack[1];
      return fetch(url, { headers: { Range: "bytes=" + off + "-" + (off + len - 1) } }).then(function (r) {
        if (!r.ok) throw new Error("pack " + r.status);
        return r.arrayBuffer().then(function (buf) {
          var raw = new Uint8Array(r.status === 206 ? buf : buf.slice(off, off + len));
          var text = new TextDecoder().decode(/\.bin$/.test(pack[0]) ? slUnscramble(raw, f.id) : raw);
          if (text.indexOf("<svg") < 0) throw new Error("sample damaged");
          return text;
        });
      });
    });
  }
  // The sample opens on its own when the page loads (om_demo_loaded, a passive event); the first
  // upload or drop replaces it. If it can't load, the drop zone (with its "Try the …" button) stays.
  var sampleBtn = $("om-sample");
  function loadSample(auto) {
    if (!sampleBtn || sampleBtn.disabled) return;
    var name = sampleBtn.getAttribute("data-name") || "Sample", label = sampleBtn.textContent, t0 = Date.now();
    sampleBtn.disabled = true; sampleBtn.textContent = "Loading the " + name + "…";
    if (!auto) omTrack("om_sample_click", { design: name });
    fetchSample(sampleBtn).then(function (text) {
      if (auto && S.root) return;                       // they already loaded their own file
      S.isSample = auto ? "auto" : true;
      loadSVG(text, name + ".svg");
      if (auto) omTrack("om_demo_loaded", { design: name, ms: Date.now() - t0 });
    }).catch(function (err) {
      if (!auto) showErr("The sample didn't load. Check your connection, or choose your own SVG.");
      omTrack("om_upload_error", { message: ("sample: " + String(err && err.message || "failed")).slice(0, 90), auto: !!auto });
    }).then(function () { sampleBtn.disabled = false; sampleBtn.textContent = label; });
  }
  if (sampleBtn) {
    sampleBtn.addEventListener("click", function () { loadSample(false); });
    loadSample(true);
  }

  function readFile(f) {
    if (!/\.svg$/i.test(f.name) && !/svg/i.test(f.type || "")) {
      meta.textContent = "That isn't an SVG file. Export your design as SVG and try again.";
      omTrack("om_upload_error", { message: "not an svg", file_type: f.type || "unknown" });
      return;
    }
    var r = new FileReader();
    r.onload = function () { S.isSample = false; loadSVG(String(r.result), f.name); };
    r.onerror = function () {
      meta.textContent = "Couldn't read that file. Try saving it again.";
      omTrack("om_upload_error", { message: "read failed", file_type: f.type || "unknown" });
    };
    r.readAsText(f);
  }

  function loadSVG(text, name) {
    try {
      if (S.root) S.root.remove();
      paper.project.clear();
      // Shared SVG cleaner (bearly-tools-core.js). Parse, clean, then hand paper.js the cleaned
      // markup. keepDataImages keeps embedded pictures (data:image/...) in layered designs.
      if (window.BT && BT.sanitizeSvg) {
        var cleanDoc = new DOMParser().parseFromString(BT.cleanSvgText(text), "image/svg+xml");
        var cleanRoot = cleanDoc.documentElement;
        if (cleanDoc.querySelector("parsererror") || !cleanRoot || cleanRoot.nodeName.toLowerCase() !== "svg") {
          meta.textContent = "Couldn't read that SVG. Try exporting it again from your design app.";
          omTrack("om_upload_error", { message: "invalid svg" });
          return;
        }
        BT.sanitizeSvg(cleanRoot, { keepDataImages: true });
        text = new XMLSerializer().serializeToString(cleanRoot);
      }
      var item = paper.project.importSVG(text, { expandShapes: true, insert: true });
      if (!item || !item.bounds || item.bounds.width === 0 || item.bounds.height === 0) {
        meta.textContent = "Couldn't find any shapes in that SVG.";
        omTrack("om_upload_error", { message: "no shapes" });
        return;
      }
      item.position = item.position.subtract(item.bounds.topLeft); // topLeft -> (0,0)
      S.root = item;
      S.fileName = name.replace(/\.svg$/i, "") || "design";
      S.nativeW = item.bounds.width; S.nativeH = item.bounds.height;
      S.aspect = S.nativeW / S.nativeH;
      S.engaged = false;
      var hasText = /<text[\s>]/i.test(text);
      textWarn.classList.toggle("om-hidden", !hasText);
      // Every new file starts with its longest side at START_IN (23 in = two 11.5 in cut widths, so a
      // square-ish design on the default 12 x 12 mat comes out as 4 equal pieces).
      if (S.aspect >= 1) { wIn.value = START_IN; hIn.value = (START_IN / S.aspect).toFixed(2); }
      else { hIn.value = START_IN; wIn.value = (START_IN * S.aspect).toFixed(2); }
      var nLayers = layersOf(item).length, nShapes = countLeaves(item);
      meta.innerHTML = (S.isSample ? "Sample: " : "") + "<b>" + esc(name) + "</b> — " + nShapes + " shape" + (nShapes === 1 ? "" : "s") +
        ", " + nLayers + " layer" + (nLayers === 1 ? "" : "s") + (S.isSample ? ". Load your own SVG to replace it." : "");
      drop.classList.add("om-hidden");
      preview.classList.remove("om-hidden");
      legend.classList.remove("om-hidden");
      showErr("");
      recomputeNow();
      if (S.isSample === "auto") return;                // opened on page load: not a start
      omTrack("om_file_upload", { shapes: nShapes, layers: nLayers, has_text: hasText, pieces: S.pieces, sample: !!S.isSample });
      omKlaviyoEvent("Started Off The Mat", { shapes: nShapes, layers: nLayers });
    } catch (err) {
      meta.textContent = "Couldn't read that SVG. Try exporting it again from your design app.";
      omTrack("om_upload_error", { message: String(err && err.message || "import failed").slice(0, 90) });
    }
  }

  function layersOf(item) {
    if (item.children && item.children.length && item.children.every(function (c) { return c instanceof paper.Group; }))
      return item.children;
    return [item];
  }
  function countLeaves(item) {
    var n = 0;
    (function walk(it) {
      if (it instanceof paper.Path || it instanceof paper.CompoundPath) n++;
      else if (it.children) it.children.forEach(walk);
    })(item);
    return n;
  }
  function collectLeaves(item, out) {
    if (item instanceof paper.Path || item instanceof paper.CompoundPath) { out.push(item); }
    else if (item.children) { item.children.slice().forEach(function (c) { collectLeaves(c, out); }); }
  }
  function enumerateLeaves(r) {
    var out = [];
    layersOf(r).forEach(function (layer, li) {
      var ls = []; collectLeaves(layer, ls);
      ls.forEach(function (p) { out.push({ li: li, p: p }); });
    });
    return out;
  }

  // ---------- size + mat inputs ----------
  var engageTimer = 0;
  function engaged() {
    if (!S.root || S.engaged) return;
    clearTimeout(engageTimer);
    engageTimer = setTimeout(function () {
      if (S.engaged) return;
      S.engaged = true;
      var m = matSize();
      omTrack("om_layout_customized", { mat: matLabel(), mat_w: m[0], mat_h: m[1],
        width_in: num(wIn), height_in: num(hIn), pieces: S.pieces });
    }, 1200);
  }

  wIn.addEventListener("input", function () {
    if (S.root && lock.checked && num(wIn) > 0) hIn.value = (num(wIn) / S.aspect).toFixed(2);
    recompute(); engaged();
  });
  hIn.addEventListener("input", function () {
    if (S.root && lock.checked && num(hIn) > 0) wIn.value = (num(hIn) * S.aspect).toFixed(2);
    recompute(); engaged();
  });
  matSel.addEventListener("change", function () {
    customMat.classList.toggle("om-hidden", matSel.value !== "custom");
    recompute(); engaged();
  });
  [matW, matH].forEach(function (el) { el.addEventListener("input", function () { recompute(); engaged(); }); });

  // ---------- raster occupancy ----------
  function buildRaster(Wn, Hn, excl) {
    var maxPx = 1600;
    var targetPPI = Math.min(60, maxPx / Math.max(Wn, Hn));
    var res = (Wn * targetPPI) / S.nativeW * 72; // paper treats 72 units = 1in
    var src = S.root, wrap = null;
    if (excl && excl.size) {
      var temp = S.root.clone({ insert: false });
      var ls = enumerateLeaves(temp);
      excl.forEach(function (i) { if (ls[i]) ls[i].p.remove(); });
      // invisible full-bounds rect keeps the raster aligned after removals
      var bg = new paper.Path.Rectangle({ point: [0, 0], size: [S.nativeW, S.nativeH], fillColor: "black", opacity: 0, insert: false });
      wrap = new paper.Group({ children: [bg, temp], insert: false });
      src = wrap;
    }
    var raster;
    try { raster = src.rasterize({ resolution: res, insert: false }); }
    catch (e) { raster = src.rasterize(res, false); }
    if (wrap) wrap.remove();
    var cv = raster.canvas;
    var ppi = cv.width / Wn;
    var data = cv.getContext("2d").getImageData(0, 0, cv.width, cv.height).data;
    var cols = new Uint8Array(cv.width), rows = new Uint8Array(cv.height);
    for (var y = 0; y < cv.height; y++) {
      for (var x = 0; x < cv.width; x++) {
        if (data[(y * cv.width + x) * 4 + 3] > 12) { cols[x] = 1; rows[y] = 1; }
      }
    }
    return { canvas: cv, ppi: ppi, cols: cols, rows: rows, w: cv.width, h: cv.height };
  }

  // A shape is kept whole when it fits the cut area but a cut line crosses it.
  function classify(cutsX, cutsY, scIn, mw, mh, Wn, Hn) {
    var xs = [0].concat(cutsX, [Wn]), ys = [0].concat(cutsY, [Hn]);
    var eps = 1e-3;
    var idxOf = function (arr, v) { var i = 0; while (i < arr.length - 2 && v >= arr[i + 1] - eps) i++; return i; };
    var set = new Set();
    S.leaves.forEach(function (lf, i) {
      var b = lf.p.bounds;
      var l = b.left * scIn, r = b.right * scIn, t = b.top * scIn, bo = b.bottom * scIn;
      if (r - l > mw + eps || bo - t > mh + eps) return; // truly oversized -> gets tiled
      var crossed = idxOf(xs, l + eps) !== idxOf(xs, r - eps) || idxOf(ys, t + eps) !== idxOf(ys, bo - eps);
      if (crossed) set.add(i);
    });
    return set;
  }

  // Shelf-pack whole shapes onto mat-sized parts sheets (inches).
  function packWholes(scIn, mw, mh) {
    var pad = 0.15;
    var items = Array.from(S.wholeSet).map(function (i) {
      var b = S.leaves[i].p.bounds;
      return { i: i, w: b.width * scIn, h: b.height * scIn };
    }).sort(function (a, b) { return b.h - a.h; });
    var sheets = [];
    items.forEach(function (it) {
      var done = false;
      for (var si = 0; si < sheets.length && !done; si++) {
        var s = sheets[si];
        for (var k = 0; k < s.shelves.length; k++) {
          var sh = s.shelves[k];
          if (it.h <= sh.h + 1e-6 && sh.x + it.w <= mw + 1e-6) {
            s.items.push({ i: it.i, x: sh.x, y: sh.y, w: it.w, h: it.h });
            sh.x += it.w + pad; done = true; break;
          }
        }
        if (!done && s.nextY + it.h <= mh + 1e-6) {
          s.shelves.push({ y: s.nextY, h: it.h, x: it.w + pad });
          s.items.push({ i: it.i, x: 0, y: s.nextY, w: it.w, h: it.h });
          s.nextY += it.h + pad;
          done = true;
        }
      }
      if (!done) {
        sheets.push({ shelves: [{ y: 0, h: it.h, x: it.w + pad }],
                      items: [{ i: it.i, x: 0, y: 0, w: it.w, h: it.h }],
                      nextY: it.h + pad });
      }
    });
    sheets.forEach(function (s) {
      s.w = Math.max.apply(null, s.items.map(function (o) { return o.x + o.w; }));
      s.h = Math.max.apply(null, s.items.map(function (o) { return o.y + o.h; }));
    });
    return sheets;
  }

  // Straight grid: a cut every full cut-area length.
  function computeCuts(lengthIn, tileIn) {
    var cuts = [];
    for (var pos = tileIn; lengthIn - pos > 1e-6; pos += tileIn) cuts.push(pos);
    return cuts;
  }

  function tileEmpty(rst, x0, y0, x1, y1) {
    var px0 = Math.max(0, Math.floor(x0 * rst.ppi)), px1 = Math.min(rst.w - 1, Math.ceil(x1 * rst.ppi));
    var py0 = Math.max(0, Math.floor(y0 * rst.ppi)), py1 = Math.min(rst.h - 1, Math.ceil(y1 * rst.ppi));
    var anyCol = false, x, y;
    for (x = px0; x <= px1; x++) if (rst.cols[x]) { anyCol = true; break; }
    if (!anyCol) return true;
    var anyRow = false;
    for (y = py0; y <= py1; y++) if (rst.rows[y]) { anyRow = true; break; }
    if (!anyRow) return true;
    var w = px1 - px0 + 1, h = py1 - py0 + 1;
    if (w <= 0 || h <= 0) return true;
    var d = rst.canvas.getContext("2d").getImageData(px0, py0, w, h).data;
    for (var i = 3; i < d.length; i += 4) if (d[i] > 12) return false;
    return true;
  }

  // ---------- recompute + preview ----------
  var rafId = 0;
  function recompute() {
    if (!S.root) return;
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(recomputeNow);
  }

  function recomputeNow() {
    var Wn = num(wIn), Hn = num(hIn);
    var m = matSize(), mw = m[0], mh = m[1];
    if (!Wn || !Hn || !mw || !mh) return;

    S.leaves = enumerateLeaves(S.root);
    var scIn = Wn / S.nativeW; // inches per native unit

    S.rasterFull = buildRaster(Wn, Hn, null);
    S.cutsX = computeCuts(Wn, mw);
    S.cutsY = computeCuts(Hn, mh);
    S.wholeSet = classify(S.cutsX, S.cutsY, scIn, mw, mh, Wn, Hn);
    S.rasterCut = S.wholeSet.size ? buildRaster(Wn, Hn, S.wholeSet) : S.rasterFull;
    S.sheets = packWholes(scIn, mw, mh);

    var xs = [0].concat(S.cutsX, [Wn]), ys = [0].concat(S.cutsY, [Hn]);
    S.tiles = [];
    var kept = 0;
    for (var r = 0; r < ys.length - 1; r++) {
      for (var c = 0; c < xs.length - 1; c++) {
        var t = { x: xs[c], y: ys[r], w: xs[c + 1] - xs[c], h: ys[r + 1] - ys[r], row: r + 1, col: c + 1 };
        t.empty = tileEmpty(S.rasterCut, t.x, t.y, t.x + t.w, t.y + t.h);
        if (!t.empty) kept++;
        S.tiles.push(t);
      }
    }
    var nW = S.wholeSet.size, nS = S.sheets.length, blank = S.tiles.length - kept;
    S.pieces = kept + nS; S.tileCount = kept;
    summary.innerHTML = "<b>" + S.pieces + " piece" + (S.pieces === 1 ? "" : "s") + "</b> — " +
      kept + " mat tile" + (kept === 1 ? "" : "s") + " (" + (ys.length - 1) + " × " + (xs.length - 1) + " grid)" +
      (nW ? "<br>" + nW + " small shape" + (nW === 1 ? "" : "s") + " kept whole on " + nS + " parts sheet" + (nS === 1 ? "" : "s") : "") +
      (blank ? "<br>" + blank + " blank tile" + (blank === 1 ? "" : "s") + " skipped" : "") +
      "<br>Finished size " + fmt(Wn) + " × " + fmt(Hn) + " in";
    dlCombined.disabled = dlZip.disabled = (S.pieces === 0);
    drawPreview(Wn, Hn);
  }

  function roundRect(ctx, x, y, w, h, r) {
    if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); return; }
    ctx.beginPath();
    ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }

  function drawPreview(Wn, Hn) {
    var availW = stage.clientWidth - 44, availH = stage.clientHeight - 44;
    if (availW <= 0 || availH <= 0) return;
    var scale = Math.min(availW / Wn, availH / Hn);
    var dpr = window.devicePixelRatio || 1;
    preview.width = Math.round(Wn * scale * dpr);
    preview.height = Math.round(Hn * scale * dpr);
    preview.style.width = (Wn * scale) + "px";
    preview.style.height = (Hn * scale) + "px";
    var ctx = preview.getContext("2d");
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var px = function (v) { return v * scale; };

    // paper + one-inch grid
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, px(Wn), px(Hn));
    ctx.strokeStyle = "rgba(31,26,28,.07)";
    ctx.lineWidth = 1;
    var x, y;
    for (x = 1; x < Wn; x++) { ctx.beginPath(); ctx.moveTo(px(x), 0); ctx.lineTo(px(x), px(Hn)); ctx.stroke(); }
    for (y = 1; y < Hn; y++) { ctx.beginPath(); ctx.moveTo(0, px(y)); ctx.lineTo(px(Wn), px(y)); ctx.stroke(); }

    ctx.drawImage(S.rasterFull.canvas, 0, 0, px(Wn), px(Hn));

    // cut lines
    ctx.strokeStyle = "#FF5A3C";
    ctx.setLineDash([7, 5]);
    ctx.lineWidth = 1.6;
    S.cutsX.forEach(function (cx) { ctx.beginPath(); ctx.moveTo(px(cx), 0); ctx.lineTo(px(cx), px(Hn)); ctx.stroke(); });
    S.cutsY.forEach(function (cy) { ctx.beginPath(); ctx.moveTo(0, px(cy)); ctx.lineTo(px(Wn), px(cy)); ctx.stroke(); });
    ctx.setLineDash([]);

    // tile labels
    var family = getComputedStyle(root).fontFamily || "sans-serif";
    ctx.textAlign = "center";
    S.tiles.forEach(function (t) {
      if (t.empty) return;
      var cx = px(t.x + t.w / 2), cy = px(t.y + t.h / 2);
      var label = "R" + t.row + "C" + t.col;
      var dims = t.w.toFixed(1) + " × " + t.h.toFixed(1) + "\"";
      ctx.font = "700 12px " + family;
      var bw = ctx.measureText(label).width;
      ctx.font = "400 11px " + family;
      bw = Math.max(bw, ctx.measureText(dims).width) + 16;
      ctx.fillStyle = "rgba(31,26,28,.74)";
      roundRect(ctx, cx - bw / 2, cy - 17, bw, 34, 7);
      ctx.fill();
      ctx.fillStyle = "#fff";
      ctx.font = "700 12px " + family;
      ctx.fillText(label, cx, cy - 3);
      ctx.font = "400 11px " + family;
      ctx.fillText(dims, cx, cy + 11);
    });
  }
  var resizeT = 0;
  window.addEventListener("resize", function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { if (S.root && S.rasterFull) drawPreview(num(wIn), num(hIn)); }, 120);
  });

  // ---------- clipping + export ----------
  function buildPieces() {
    var Wn = num(wIn);
    var sc = (Wn * UPI) / S.nativeW; // native units -> export units
    var scaled = S.root.clone({ insert: true });
    scaled.scale(sc, new paper.Point(0, 0));
    scaled.position = scaled.position.subtract(scaled.bounds.topLeft);

    // leaves per layer with the same global indices used in recompute
    var byLayer = [], gi = 0;
    layersOf(scaled).forEach(function (layer) {
      var ls = []; collectLeaves(layer, ls);
      byLayer.push(ls.map(function (p) { return { p: p, idx: gi++ }; }));
    });

    var tilesOut = [];
    S.tiles.forEach(function (t) {
      if (t.empty) return;
      var rect = new paper.Path.Rectangle({ point: [t.x * UPI, t.y * UPI], size: [t.w * UPI, t.h * UPI], insert: false });
      var rB = rect.bounds;
      var pieceLayers = [];
      byLayer.forEach(function (ls) {
        var kept = [];
        ls.forEach(function (o) {
          var p = o.p;
          if (S.wholeSet.has(o.idx)) return; // goes whole onto a parts sheet
          if (!p.bounds.intersects(rB) && !rB.contains(p.bounds)) return;
          var piece;
          if (rB.contains(p.bounds)) piece = p.clone({ insert: false });
          else {
            try { piece = p.intersect(rect, { insert: false }); }
            catch (e) { piece = p.clone({ insert: false }); }
          }
          if (piece && !piece.isEmpty()) kept.push(piece);
          else if (piece) piece.remove();
        });
        if (kept.length) pieceLayers.push(new paper.Group({ children: kept, insert: false }));
      });
      if (!pieceLayers.length) return;
      var group = new paper.Group({ children: pieceLayers, insert: false });
      group.translate(new paper.Point(-t.x * UPI, -t.y * UPI));
      tilesOut.push({ tile: t, group: group });
    });

    // parts sheets: whole-kept shapes repacked, layer order preserved
    var flat = [];
    byLayer.forEach(function (ls, li) { ls.forEach(function (o) { flat[o.idx] = { p: o.p, li: li }; }); });
    var sheetsOut = S.sheets.map(function (s, si) {
      var kids = s.items.slice()
        .sort(function (a, b) { return flat[a.i].li - flat[b.i].li || a.i - b.i; })
        .map(function (it) {
          var c = flat[it.i].p.clone({ insert: false });
          c.translate(new paper.Point(it.x * UPI - c.bounds.left, it.y * UPI - c.bounds.top));
          return c;
        });
      return { n: si + 1, w: s.w, h: s.h, group: new paper.Group({ children: kids, insert: false }) };
    });

    scaled.remove();
    return { tiles: tilesOut, sheets: sheetsOut };
  }

  function wrapSVG(inner, wInches, hInches) {
    return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="' + wInches +
      'in" height="' + hInches + 'in" viewBox="0 0 ' + (wInches * UPI) + " " + (hInches * UPI) + '">\n' + inner + "\n</svg>";
  }

  function exportZip(done) {
    var built = buildPieces();
    var zip = new JSZip();
    built.tiles.forEach(function (o) {
      zip.file((window.BT && BT.brandName ? BT.brandName(S.fileName + "-R" + o.tile.row + "C" + o.tile.col + ".svg") : S.fileName + "-R" + o.tile.row + "C" + o.tile.col + ".svg"),
        wrapSVG(o.group.exportSVG({ asString: true }), +o.tile.w.toFixed(4), +o.tile.h.toFixed(4)));
      o.group.remove();
    });
    built.sheets.forEach(function (s) {
      zip.file((window.BT && BT.brandName ? BT.brandName(S.fileName + "-parts" + s.n + ".svg") : S.fileName + "-parts" + s.n + ".svg"),
        wrapSVG(s.group.exportSVG({ asString: true }), +s.w.toFixed(3), +s.h.toFixed(3)));
      s.group.remove();
    });
    zip.generateAsync({ type: "blob" }).then(function (blob) {
      downloadBlob(blob, S.fileName + "-pieces.zip");
      done(null);
    }, function (e) { done(e); });
  }

  function exportCombined(done) {
    var built = buildPieces();
    var GAP = 0.25; // inches between pieces
    var rows = {};
    built.tiles.forEach(function (p) { (rows[p.tile.row] = rows[p.tile.row] || []).push(p); });
    var y = 0, sheetW = 0, parts = [];
    Object.keys(rows).sort(function (a, b) { return a - b; }).forEach(function (rk) {
      var x = 0, rowH = 0;
      rows[rk].sort(function (a, b) { return a.tile.col - b.tile.col; }).forEach(function (o) {
        o.group.translate(new paper.Point(x * UPI, y * UPI));
        parts.push(o.group.exportSVG({ asString: true }));
        o.group.remove();
        x += o.tile.w + GAP;
        rowH = Math.max(rowH, o.tile.h);
      });
      sheetW = Math.max(sheetW, x - GAP);
      y += rowH + GAP;
    });
    if (built.sheets.length) { // parts sheets on a final row
      var x2 = 0, rowH2 = 0;
      built.sheets.forEach(function (s) {
        s.group.translate(new paper.Point(x2 * UPI, y * UPI));
        parts.push(s.group.exportSVG({ asString: true }));
        s.group.remove();
        x2 += s.w + GAP;
        rowH2 = Math.max(rowH2, s.h);
      });
      sheetW = Math.max(sheetW, x2 - GAP);
      y += rowH2 + GAP;
    }
    var svg = wrapSVG(parts.join("\n"), +sheetW.toFixed(4), +(y - GAP).toFixed(4));
    downloadBlob(new Blob([svg], { type: "image/svg+xml" }), S.fileName + "-combined.svg");
    done(null);
  }

  // ---------- Download popup (shared core) ----------
  // BT.runWithProgress owns the popup, the email step and the × / Escape / backdrop
  // close. `work` returns a promise that rejects when the export fails, so the core
  // closes the popup and shows the error as a toast.
  var EXPORT_ERR = "Export failed. Try again, or try a smaller finished size.";
  function reenableDownloads() { dlCombined.disabled = dlZip.disabled = (S.pieces === 0); }

  function runExport(finishWork) {
    dlCombined.disabled = dlZip.disabled = true;
    var work = function () {
      return new Promise(function (resolve, reject) {
        finishWork(function (err) { if (err) reject(err); else resolve(); });
      });
    };
    if (window.BT && BT.runWithProgress) {
      BT.runWithProgress({
        stages: [
          { p: 20, wait: 350, text: "Reading your design…" },
          { p: 55, wait: 850, text: "Scaling to " + fmt(num(wIn)) + " × " + fmt(num(hIn)) + " in…" },
          { p: 84, wait: 850, text: "Cutting it into " + S.pieces + " piece" + (S.pieces === 1 ? "" : "s") + "…" }
        ],
        gateText: "Your file is almost ready! Enter your email to get it.",
        doneText: "Your file is ready!",
        errorText: "Something went wrong making your file. Try again, or try a smaller size.",
        work: work,
        onEnd: function (r) {
          if (r.status === "error") showErr(EXPORT_ERR);
          reenableDownloads();
        }
      }).then(function (r) { if (r.status === "busy") reenableDownloads(); });
    } else {
      // Old core cached: no popup, just make the file.
      Promise.resolve().then(work).catch(function () { showErr(EXPORT_ERR); }).then(reenableDownloads);
    }
  }

  // ---------- Download buttons ----------
  function dlProps(kind) {
    var m = matSize();
    return { kind: kind, pieces: S.pieces, tiles: S.tileCount, parts_sheets: S.sheets.length,
             mat: matLabel(), mat_w: m[0], mat_h: m[1], width_in: num(wIn), height_in: num(hIn) };
  }
  dlCombined.addEventListener("click", function () {
    if (!S.root || !S.pieces) return;
    showErr("");
    runExport(function (done) {
      exportCombined(function (err) {
        if (!err) {
          omTrack("om_download_click", dlProps("combined"));
          omKlaviyoEvent("Used Off The Mat", dlProps("combined"));
        }
        done(err);
      });
    });
  });
  dlZip.addEventListener("click", function () {
    if (!S.root || !S.pieces) return;
    showErr("");
    runExport(function (done) {
      exportZip(function (err) {
        if (!err) {
          omTrack("om_download_click", dlProps("zip"));
          omKlaviyoEvent("Used Off The Mat", dlProps("zip"));
        }
        done(err);
      });
    });
  });
})();